module.exports = __webpack_public_path__ + "img/howoto_sp.e7bc6462.png";